import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const StoreDetailsReportSection = "/reports/finance/store";

export const StoreDetailsReportListPath = StoreDetailsReportSection;

export enum StoreDetailsFinanceListUrlFiltersEnum {
  query = "query"
}

export enum StoreDetailsFinanceListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  storeStatus = "storeStatus"
}
export type StoreDetailsFinanceListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "download"
  | TabActionDialog;
export type StoreDetailsFinanceListUrlFilters = Filters<
  StoreDetailsFinanceListUrlFiltersEnum
> &
  FiltersWithMultipleValues<
    StoreDetailsFinanceListUrlFiltersWithMultipleValues
  >;

export type StoreDetailsFinanceListUrlQueryParams = ActiveTab &
  StoreDetailsFinanceListUrlFilters &
  BulkAction &
  Dialog<StoreDetailsFinanceListUrlDialog> &
  Pagination &
  SingleAction;

export const StoreDetailsFinanceListUrl = (
  params?: StoreDetailsFinanceListUrlQueryParams
) => StoreDetailsReportListPath + "?" + stringifyQs(params);
